import * as yup from "yup";
import Drawer from "../../../../assets/vfx/drawer/drawer";
import { CheckboxGroup } from "../../../../assets/vfx/form/components/selection/formCheckboxGroup";
import Form from "../../../../assets/vfx/form/form";
import { ClaimDto, RoleClaimDto } from "../../../../services/dto";
import { DropdownOption } from "../../../../assets/vfx/controls/components/dropdown/controlDropdown";
import { Constants } from "../../../../assets/utils/lib/constants";
import { LookupDto } from "../../../../assets/utils/lib/lookupDto";
import { DrawerFormSaveResult, hasClientErrorOperationStatusCode } from "../../../../assets/utils/lib";

interface RolePermissionLookupProps {
  permission: LookupDto[];
  role: DropdownOption[];
}

interface RolePermissionFormDataProps {
  roleId: string;
  claim?: string[] | undefined;
}

interface RolePermissionFormProps {
  data?: RolePermissionFormDataProps | undefined;
  lookups: RolePermissionLookupProps | undefined;
  show: boolean;
  loading?: boolean;
  onHide: () => void;
  onSave: (values: any) => DrawerFormSaveResult;
}

const validationSchema = yup.object().shape({
  roleId: yup.string().required("Role is required."),
});

export const RolePermissionForm = (props: RolePermissionFormProps) => {
  const permissionOptions =
    props.lookups?.permission?.map((lookup) => ({
      label: lookup.display as string,
      value: lookup.id as string,
    })) ?? [];

  const mapToRoleClaimDto = (
    data: RolePermissionFormDataProps
  ): RoleClaimDto => {
    const claims =
      (data?.claim?.map((id) => {
        const permission = props.lookups?.permission.find((x) => x.id === id);
        return {
          id: id,
          claimTypeId: permission?.parentId,
          name: permission?.display,
        };
      }) as ClaimDto[]) || [];

    return {
      roleId: data.roleId,
      claim: claims,
    };
  };

  const onSubmit = (data: RolePermissionFormDataProps) => {
    const payload = mapToRoleClaimDto(data);
    return Promise.resolve(props.onSave(payload)).then((result) => {
        if (hasClientErrorOperationStatusCode(result)) {
            return;
        }

        props.onHide();
    });
  };

  return (
    <Drawer.Form
      className="w-30"
      show={props.show}
      backdrop={true}
      placement="end"
      scroll={true}
      onHide={props.onHide}
      title="Role Permissions"
      initialValues={props.data ?? {}}
      validationSchema={validationSchema}
      on_Submit={onSubmit}
      enableReinitialize
    >
      <Form.Dropdown
        name="roleId"
        label="Role"
        isLoading={props.loading}
        options={props.lookups?.role}
        blankOption={{
          key: Constants.emptyGuid,
          display: "Select Role",
          value: Constants.emptyString,
        }}
        disabled
      />

      <CheckboxGroup
        isLoading={props.loading}
        columns={3}
        label="Permission"
        name="claim"
        options={permissionOptions}
      />
    </Drawer.Form>
  );
};
